/* eslint-disable no-restricted-imports */
import {LobbyImage} from '@colonist/types'
import {notificationController} from '../../../../code/client/shared/scripts/EntryShared'
import React, {createContext, useContext, useState, ReactNode} from 'react'
import {UIMutePlayer} from '../../../../code/client/shared/scripts/ui_player_options_popup/UIMutePlayer'

// @TODO: @Dang remove this when UIMutePlayer migrated to React. Also refactor to use userId instead of username
let globalMutePlayerSetter: undefined | ((mutedPlayers: string[]) => void)
export function setGlobalMutePlayer(mutedPlayers: string[]) {
    if(globalMutePlayerSetter) globalMutePlayerSetter([...mutedPlayers])
}

const UIMutePlayerContext = createContext<{
    mutedPlayers: string[]
    toggleMuteForPlayer: (playerName: string) => void
    mutePlayer: (playerName: string) => void
    unmutePlayer: (playerName: string) => void
    isMuted: (playerName: string) => boolean
}>({
            mutedPlayers: [],
            toggleMuteForPlayer: () => null,
            mutePlayer: () => null,
            unmutePlayer: () => null,
            isMuted: () => false,
        })

export function UIMutePlayerProvider({children}: { children: ReactNode }) {
    const [mutedPlayers, setMutedPlayers] = useState<string[]>([])
    globalMutePlayerSetter = setMutedPlayers

    const isMuted = (playerName: string) => mutedPlayers.includes(playerName)

    const mutePlayer = (playerName: string) => {
        if(isMuted(playerName)) return
        // TODO: Currently this will also trigger setMutedPlayers
        UIMutePlayer.mutePlayer(playerName)
    }

    const unmutePlayer = (playerName: string) => {
        if(!isMuted(playerName)) return
        // TODO: Currently this will also trigger setMutedPlayers
        UIMutePlayer.unmutePlayer(playerName)
    }

    const toggleMuteForPlayer = (playerName: string) => {
        const muted = isMuted(playerName)

        muted ? unmutePlayer(playerName) : mutePlayer(playerName)
        const notificationKey = muted ? 'strings:popups.notification.userUnmuted' : 'strings:popups.notification.userMuted'
        notificationController.showNotification(LobbyImage.Chat, {key: notificationKey, options: {username: playerName}}, 2000)
    }

    return (
        <UIMutePlayerContext.Provider
            value={{
                mutedPlayers: mutedPlayers,
                toggleMuteForPlayer: toggleMuteForPlayer,
                mutePlayer: mutePlayer,
                unmutePlayer: unmutePlayer,
                isMuted: isMuted,
            }}
        >
            {children}
        </UIMutePlayerContext.Provider>
    )
}

export function useUIMutePlayerContext() {
    const context = useContext(UIMutePlayerContext)
    if(context == null) {
        throw new Error('useUIMutePlayer must be used within the UIMutePlayerProvider')
    }
    return context
}
